import React from 'react';

import PropTypes from 'prop-types';

import {
  DEFAULT_HELP_TOOLTIP_MESSAGE,
  DEFAULT_LABEL,
  DEFAULT_NAME,
  DEFAULT_PLACEHOLDER,
  MAX_INPUT_LENGTH_WARNING,
  MIN_INPUT_LENGTH_WARNING,
} from './SeoOgTitle.constants';
import SeoTitle from '../SeoTitle';

import './SeoOgTitle.scss';

const propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

const defaultProps = {
  title: undefined,
  placeholder: DEFAULT_PLACEHOLDER,
  required: false,
};

export default function SeoOgTitle({ title: titleProp, placeholder, required }) {
  return (
    <SeoTitle
      title={titleProp}
      showWarnings
      placeholder={placeholder}
      name={DEFAULT_NAME}
      label={DEFAULT_LABEL}
      helpTooltipMessage={DEFAULT_HELP_TOOLTIP_MESSAGE}
      maxInputLengthWarning={MAX_INPUT_LENGTH_WARNING}
      minInputLengthWarning={MIN_INPUT_LENGTH_WARNING}
      hideAppendixDropdown
      hideAiAssistant
      required={required}
    />
  );
}

SeoOgTitle.propTypes = propTypes;
SeoOgTitle.defaultProps = defaultProps;
